import { LOGO_URL } from "@/lib/constants";

const handleAnchor = (href) => (e) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center pt-32 pb-24 overflow-hidden"
    >
      {/* Soft background ornament */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full bg-accent/10 blur-3xl" />
        <div className="absolute bottom-0 left-0 h-px w-full bg-border/70" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 w-full">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <h1
              data-testid="hero-headline"
              className="font-serif text-5xl sm:text-6xl lg:text-7xl text-primary leading-[1.04] tracking-tight text-balance"
            >
              Building enduring software companies with{" "}
              <em className="italic text-primary/95">discipline</em>.
            </h1>

            <p
              data-testid="hero-subheadline"
              className="mt-10 text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-2xl text-pretty"
            >
              Duneworth is an operating company that builds, owns, and scales
              modern software platforms — beginning in golf, and expanding into
              adjacent markets where focused software, distribution, and
              operational rigor can compound for decades.
            </p>

            <p
              data-testid="hero-supporting"
              className="mt-6 text-base text-primary/70 italic font-serif text-xl max-w-xl"
            >
              We are not a studio chasing ideas. We are an operator building durable companies.
            </p>

            <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:gap-5">
              <a
                href="#portfolio"
                onClick={handleAnchor("#portfolio")}
                data-testid="hero-cta-primary"
                className="inline-flex items-center justify-center bg-primary text-primary-foreground hover:bg-primary/85 px-8 py-4 text-[12px] uppercase tracking-[0.22em] transition-colors duration-300"
              >
                View the Portfolio
              </a>
              <a
                href="#contact"
                onClick={handleAnchor("#contact")}
                data-testid="hero-cta-secondary"
                className="inline-flex items-center justify-center bg-transparent text-primary border border-primary hover:bg-primary hover:text-primary-foreground px-8 py-4 text-[12px] uppercase tracking-[0.22em] transition-colors duration-300"
              >
                Contact Duneworth
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -inset-6 border border-border" aria-hidden="true" />
              <div className="absolute -inset-12 border border-accent/30" aria-hidden="true" />
              <img
                src={LOGO_URL}
                alt="Duneworth — a serif D enclosing dunes, cliffs, and ocean, set above the Duneworth wordmark"
                className="relative w-[320px] sm:w-[400px] lg:w-[460px] h-auto object-contain bg-card"
                data-testid="hero-logo"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
